var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SlicedImageLayer',{attrs:{"bounds":_vm.bounds,"images":_vm.images}})}
var staticRenderFns = []

export { render, staticRenderFns }